export const isValidUrl = (url: string): boolean => {
  const pattern = /^(?:https:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;%=.]+$/
  const newUrl = url.replace(/^(http(s)?:\/\/)/, '')
  return pattern.test(newUrl)
}
